import { Texture } from "@pixi/core";
import { NewsResourcePackage } from "../../../resources/NewsResourcePackage";
import { NewsCardView } from "./NewsCardView";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { IPlayerModel } from "by/gamefactory/cityversetycoon/scenes/common/models/IPlayerModel";
import { RaidNewsCard } from "../../../flow/impl/news/RaidNewsCard";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { UserProfileResourcePackage } from "by/gamefactory/cityversetycoon/scenes/popups/userprofile/resources/UserProfileResourcePackage";

export class RaidNewsCardView extends NewsCardView {
    private playerModel: IPlayerModel;
    private newsCard: RaidNewsCard;

    public constructor(
        canvasScaler: ICanvasScaler,
        newsResourcesPackage: NewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        guestAvatar: Texture,
        guestName: string,
        playerModel: IPlayerModel,
        newsCard: RaidNewsCard
    ) {
        super(
            newsResourcesPackage.assets_views_news_raid_blocked_background_png,
            userProfileResources,
            guestAvatar,
            guestName,
            "TRIED TO RAID YOU",
            canvasScaler
        );
        this.playerModel = playerModel;
        this.newsCard = newsCard;
    }

    protected layoutData(): void {
        this.avatar.position.set(444, 92);
        this.guestNameText.position.set(
            525,
            96
        );
        this.messageText.position.set(
            401,
            173
        );
    }

    public accrueResult(waitForComplete: PromiseCompletionSource<void>): void {
        this.playerModel.subtractShields(this.newsCard.costInShields);
        waitForComplete.complete();
    }
}
